import { render, staticRenderFns } from "./sayiinput.vue?vue&type=template&id=18217129&scoped=true"
import script from "./sayiinput.vue?vue&type=script&lang=js"
export * from "./sayiinput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18217129",
  null
  
)

export default component.exports